<p [innerHTML]="data | translate"></p>
